/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceExecuteStandardResponse {
    getFixupPrototypeFunction() { return ComplianceExecuteStandardResponse.fixupPrototype; }

    static newInstance(model: Partial<ComplianceExecuteStandardResponse>): ComplianceExecuteStandardResponse {
        let obj = Object.assign(new ComplianceExecuteStandardResponse(), model);
        ComplianceExecuteStandardResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceExecuteStandardResponse>): ComplianceExecuteStandardResponse {
        if (!model) return null;
        return ComplianceExecuteStandardResponse.newInstance(<ComplianceExecuteStandardResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceExecuteStandardResponse) {
        if (!obj) return;

        models.ComplianceExecuteStandardResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceExecuteStandardResponse): boolean {
        Object.setPrototypeOf(obj, ComplianceExecuteStandardResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.assessment_job_numbers) {
            for (let val of this.assessment_job_numbers) {
                models.ComplianceAssessmentJobDetail.fixupPrototype(val);
            }
        }
    }

    /**
     * Assessment job numbers per service account
     */
    assessment_job_numbers: Array<models.ComplianceAssessmentJobDetail>;

    /**
     * Service accounts with invalid credentials or where compliance assessment feature is not enabled
     */
    invalid_service_account_ids: Array<string>;

}
